interface IScalesHeightKpiTable {
  menuToggle: boolean
  isGraphic: boolean
  hasSessions: boolean
}

export const scalesHeightOtbTable = ({
  menuToggle,
  isGraphic,
  hasSessions
}: IScalesHeightKpiTable) => {
  if (menuToggle && isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 464px)'
    }
    return 'calc(100vh - 432px)'
  }

  if (!menuToggle && isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 592px)'
    }
    return 'calc(100vh - 560px)'
  }

  if (menuToggle && !isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 187px)'
    }
    return 'calc(100vh - 155px)'
  }

  if (!menuToggle && !isGraphic) {
    if (hasSessions) {
      return 'calc(100vh - 328px)'
    }
    return 'calc(100vh - 296px)'
  }
}
